const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class CompleteTheStyleTabs extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.tabs = this.els.tab?.elements
    this.panels = this.els.panel?.elements

    if (!this.tabs) return

    this.handleClick = this.handleClick.bind(this)
    document.addEventListener('click', this.handleClick)

    this.setupCarouselObserver()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.resizeObserver?.disconnect()
    this.carousel?.destroy()
  }

  setupCarouselObserver () {
    if (!this.els.slides?.exists || !this.els.slide?.exists) return
    if (this.els.slide.elements.length <= 6) return

    const handleResize = debounce(() => {
      if (this.carousel) {
        this.carousel.update()
      } else {
        this.carousel = this.setupCarousel()
      }
    }, 100)

    this.resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === 0) return

      handleResize()
    })

    this.resizeObserver.observe(this.els.slides.element)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'free',
        slides: {
          perView: 'auto',
          spacing: 0,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  handleClick (e) {
    const target =
      e.target.closest(this.els.tab.selector) ||
      (this.externalEls.trigger &&
        e.target.closest(this.externalEls.trigger.selector))
    if (!target) return

    const id = target.dataset.productId

    if (!id) return

    this.updateTabs(id)
    this.updatePanels(id)
  }

  updateTabs (id) {
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-pressed', tab.dataset.productId === id)
    })
  }

  updatePanels (id) {
    this.panels.forEach(panel => {
      panel.setAttribute('aria-hidden', panel.dataset.productId !== id)
    })
  }
}

if (!customElements.get('complete-the-style-tabs')) {
  customElements.define('complete-the-style-tabs', CompleteTheStyleTabs)
}
